import * as actionTypes from "~/store/action_types";

const estimates = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.FETCH_ACTIVITY_LOGS_SUCCESS: {
      const { response = { entities: {} } } = action;
      const { entities = { estimates: {} } } = response;
      const { estimates = {} } = entities;
      return { ...state, ...estimates };
    }
    default:
      return state;
  }
};

export default estimates;
